<template>
    <div class="by-variants-mainpage" v-if="calculatorPage != null && indexPage != null && setup != null">
        <div class="container">
            <div class="section-title-new">
                <h2>{{indexPage.by_title}}</h2>
            </div>
            <div class="column-container">
                <div class="col-left">
                    <hypothecCalculator class="calculator-homepage"></hypothecCalculator>
                </div>
                <div class="col-right">
                    <div class="another-by-item">
                        <div class="another-by-item-container">
                            <h3>{{ indexPage.by_another_title }}</h3>
                            <div class="another-nav">
                                <ul>
                                    <li v-for="item in indexPage.by_another_nav">
                                        <router-link :to="item.link">
                                            <div class="icon-img"><img :src="item.icon" alt=""></div>
                                            <span>{{ item.name }}</span>
                                        </router-link>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="variants-bottom-nav">
                            <ul>
                                <li v-for="item in indexPage.by_nav">
                                    <router-link :to="item.link">
                                        <span>{{ item.name }}</span>
                                        <div class="link-icon"><svgIcon name="arrow-go-right"/></div>
                                    </router-link>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
    import hypothecCalculator from '@/components/hypothec-calculator/hypothec-calculator.vue'
    import {mapGetters} from 'vuex'
    import svgIcon from '@/components/partials/SvgIcon.vue';
    export default {
        name: 'calculator-items-page',
        components: {
            hypothecCalculator,
            svgIcon,
        },
        data () {
            return {
            }
        },
        computed: mapGetters({
            calculatorPage: 'loadHypothecCalculatorPage',
            indexPage: 'loadIndexPage',
            setup: 'loadPageSetUp',
        }),
        methods: {
        },
        beforeCreate() {
             this.$store.dispatch('getNewsPageData');
        },
        created () {
        },
        mounted() {
            // this.setFilterNewsLength();
            // this.$store.watch(
            //     (state) => state.newsItemsFilter,
            //     (newValue) => {
            //         if (newValue) {
            //             this.setFilterNewsLength();
            //         }
            //     }
            // )
        }
    }
</script>

<style lang="scss">
    @import '@/styles/components/index-promo/promo-calculator.scss';
    @import '@/styles/respond/index-promo/respond-promo-calculator.scss';
    // @import '@/styles/respond/news/news-items-promo-respond.scss';
</style>